
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

const VerificationComplete = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6 max-w-md mx-auto px-4">
        <div className="flex justify-center">
          <CheckCircle2 className="h-16 w-16 text-green-500" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight">
          Verification Submitted Successfully!
        </h1>
        <p className="text-muted-foreground">
          Your verification is being reviewed. We'll notify you once it's approved.
          This usually takes 1-2 business days.
        </p>
        <Button 
          className="w-full"
          onClick={() => navigate('/profile')}
        >
          Return to Profile
        </Button>
      </div>
    </div>
  );
};

export default VerificationComplete;
